import { useCallback } from "react";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
export function usePagination(_ref) {
  var _items$data, _items$pageInfo;
  let {
    items,
    fetchMore,
    limit = LIST_PAGE_LIMIT,
    maxLength,
    loadMore = true
  } = _ref;
  const dataLength = (items === null || items === void 0 || (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) || 0;
  const hasNextPage = items === null || items === void 0 || (_items$pageInfo = items.pageInfo) === null || _items$pageInfo === void 0 ? void 0 : _items$pageInfo.hasNextPage;
  const maxLengthValid = !maxLength || maxLength && dataLength < maxLength;
  const enableLoadMore = loadMore && hasNextPage && maxLengthValid;
  const fetchMoreCallback = useCallback(async () => {
    if (loadMore && hasNextPage) {
      if (maxLength && dataLength + limit > maxLength) {
        limit = maxLength - dataLength;
      }
      await fetchMore({
        variables: {
          offset: dataLength,
          limit
        }
      });
    }
  }, [loadMore, dataLength, hasNextPage, fetchMore]);
  return {
    enableLoadMore,
    fetchMoreCallback
  };
}